<template>
  <div class="px-10">
    <v-toolbar dense flat class="mb-10">
      <div class="text-h4 primary--text">ข้อมูลรถ</div>
      <div style="width: 400px">
        <v-text-field
          class="ml-10"
          v-model="filter.start_with"
          prepend-inner-icon="mdi-magnify"
          label="ค้นหา เลขทะเบียน ชื่อลูกค้า เบอร์โทร"
          outlined
          rounded
          dense
          single-line
          hide-details
          @keyup="searchData"
        ></v-text-field>
      </div>
      <v-spacer></v-spacer>
      <v-btn color="primary" outlined small class="ml-5" @click="add()">
        <v-icon left small>mdi-plus</v-icon> เพิ่มข้อมูลรถ
      </v-btn>
    </v-toolbar>
    <v-card outlined class="mb-5">
      <v-card-text>
        <v-row>
          <v-col>
            <v-select
              label="ประเภทรถ"
              v-model="filter.car_type"
              :items="car_type"
              item-value="value"
              item-text="name"
              outlined
              rounded
              dense
              hide-details
            >
            </v-select>
          </v-col>
          <v-col>
            <v-select
              label="กรองจากวันที่ขาด"
              v-model="filter.product_type"
              :items="product_type"
              item-value="value"
              item-text="name"
              outlined
              rounded
              dense
              hide-details
            >
            </v-select>
          </v-col>
          <v-col>
            <DatePicker
              label="วันที่เริ่ม"
              :value="filter.start_date"
              @onChange="(val) => (filter.start_date = val)"
              hideDetails
              outlined
              rounded
              dense
            />
          </v-col>
          <v-col>
            <DatePicker
              label="ถึงวันที่"
              :value="filter.end_date"
              @onChange="(val) => (filter.end_date = val)"
              hideDetails
              outlined
              rounded
              dense
            />
          </v-col>
          <v-spacer />
          <v-col>
            <v-btn
              color="primary"
              small
              class="float-right"
              @click="download_excel()"
            >
              ดาวน์โหลด <v-icon right>mdi-magnify</v-icon>
            </v-btn>
          </v-col>
          <v-col>
            <v-btn color="primary" small class="float-right" @click="getData()">
              แสดงรายงาน <v-icon right>mdi-magnify</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-alert
      v-if="searchNotFound"
      type="info"
      outlined
      dense
      class="mb-5"
    >
      ค้นหาไม่เจอ กรุณาลองค้นหาจากข้อมูลอื่น เช่น ชื่อ เบอร์โทร ทะเบียนรถ เป็นต้น
    </v-alert>
    <v-data-table
      class="elevation-2 row-pointer"
      :headers="headers"
      :items="list"
      :loading="loading"
      sort-by="calories"
      :loading-text="$table_loading_text"
      :page.sync="page"
      :items-per-page="filter.item_per_page"
      hide-default-footer
      item-key="_id"
      @click:row="edit"
    >
      <template v-slot:[`item._id`]="{ item }">
        {{ getItemNumber(item) }}
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <menu-ship small v-model="item.status" />
      </template>

      <template v-slot:[`item.plate`]="{ item }">
        {{ item.plate_character }} - {{ item.plate_number }}
      </template>
      <template v-slot:[`item.car_type`]="{ item }">
        {{ getCarTypeName(car_type_dict, item.car_type) }}
      </template>

      <template v-slot:[`item.taxout_date`]="{ item }">
        <span v-if="item.taxout_date != ''">
          {{ formatDate(item.taxout_date) }}
        </span>
      </template>

      <template v-slot:[`item.third_insurance_end_date`]="{ item }">
        <span v-if="item.third_insurance_end_date != ''">
          {{ formatDate(item.third_insurance_end_date) }}
        </span>
      </template>

      <template v-slot:[`item.insurance_end_date`]="{ item }">
        <span v-if="item.insurance_end_date != ''">
          {{ formatDate(item.insurance_end_date) }}
        </span>
      </template>

      <template v-slot:[`item.ownership.phone_number`]="{ item }">
        <span >
          {{ phoneNumberFormat(item.ownership.phone_number) }}
        </span>
      </template>

      <template v-slot:footer>
        <div
          v-if="viewMode !== 'report'"
          class="d-flex justify-end align-center pa-5"
        >
          <v-btn
            text
            small
            class="mr-2"
            :disabled="loading || !canGoPrevious"
            @click="previousCursorPage"
          >
            ก่อนหน้า
          </v-btn>
          <v-btn
            color="primary"
            small
            :disabled="loading || !canGoNext"
            @click="nextCursorPage"
          >
            ถัดไป
          </v-btn>
        </div>
        <table-pagination-custom
          v-else
          :page="filter.page"
          :itemsPerPage="filter.item_per_page"
          :length="pageCount"
          @change-page="onChangePage"
          @change-items-per-page="onChangeitemsPerPage"
        />
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" color="grey" small outlined rounded>
              <v-icon>mdi-dots-horizontal</v-icon>
            </v-btn>
          </template>
          <v-list>
            <template>
              <v-list-item dense link @click="edit(item)">
                <v-list-item-title>แก้ไข</v-list-item-title>
              </v-list-item>
              <v-list-item dense link @click="remove(item)">
                <v-list-item-title>ลบ</v-list-item-title>
              </v-list-item>
            </template>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import permissionConsumer from '@/mixins/permissionConsumer';
import * as moment from 'moment';
const { getCarTypeName } = require('@/utils/carType');
const carTypeLoader = require('@/mixins/carTypeLoader');
import DatePicker from '@/components/DatePicker.vue';

export default {
  mixins: [permissionConsumer, carTypeLoader],
  components: {
    DatePicker,
  },
  data: () => ({
    loading: true,
    page: 1,
    pageCount: 0,
    cursorHistory: [null],
    cursorPage: 1,
    hasMore: false,
    nextCursor: null,
    viewMode: 'initial',
    searchCursorHistory: [null],
    searchCursorPage: 1,
    searchHasMore: false,
    searchNextCursor: null,
    searchQuery: '',
    searchNotFound: false,
    requestVersion: 0,
    timer: null,
    itemsPerPage: 10,
    showPhoneNumber: false,
    list: [],
    headers: [
      { text: '#', value: '_id', filterable: false, sortable: false, width: 0},
      { text: 'ทะเบียน', value: 'plate' },
      { text: 'จังหวัด', value: 'plate_province', filterable: false },
      { text: 'ลูกค้า', value: 'ownership.customer_name' },
      { text: 'เบอร์ติดต่อ', value: 'ownership.phone_number' },
      { text: 'ประเภทรถ', value: 'car_type', filterable: false },
      { text: 'วันที่ภาษีขาด', value: 'taxout_date' },
      { text: 'วันที่ พ.ร.บ ขาด', value: 'third_insurance_end_date' },
      { text: 'วันที่ประกันภัยขาด', value: 'insurance_end_date' },
      { text: '', value: 'actions', sortable: false, filterable: false },
    ],

    car_type: [
      { value: 0, name: 'ทั้งหมด' },
      { value: 1, name: 'รถยนต์เท่านั้น' },
      { value: 2, name: 'รย.1' },
      { value: 3, name: 'รย.2' },
      { value: 4, name: 'รย.3' },
      { value: 5, name: 'รย.12' },
      { value: 6, name: 'อื่นๆ' },
    ],
    product_type: [
      { value: 0, name: 'ทั้งหมด' },
      { value: 1, name: 'เฉพาะ ภาษี' },
      { value: 2, name: 'เฉพาะ พ.ร.บ.' },
      { value: 3, name: 'เฉพาะ ประกัน' },
      { value: 4, name: 'ภาษี + พ.ร.บ.' },
      { value: 5, name: 'พ.ร.บ. + ประกัน' },
      { value: 6, name: 'ภาษี + พ.ร.บ. + ประกัน' },
    ],
    filter: {
      branch_id: '',
      item_per_page: 20,
      page: 1,
      start_with: '',
      car_type: 0,
      product_type: 0,
      start_date: moment().add(-1, 'years').format('YYYY-MM-DD'),
      end_date: moment().add(1, 'years').format('YYYY-MM-DD'),
    },
  }),

  computed: {
    // Short label derived from the store (centralized in backend/car_types.json):
    // each label_th starts with "(code) description", so the first word is the short form.
    car_type_dict() {
      return this.$store.state.list.car_type_dict.map((item) => ({
        value: item.value,
        name: item.name.split(' ')[0],
      }));
    },
    canGoPrevious() {
      if (this.viewMode === 'search') {
        return this.searchCursorHistory.length > 1;
      }
      return this.cursorHistory.length > 1;
    },
    canGoNext() {
      if (this.viewMode === 'search') {
        return this.searchHasMore;
      }
      return this.hasMore;
    },
  },

  async created() {
    await this.loadCarTypeDict();
    this.filter.branch_id = await this.$store.state.selected_branch._id;
    await this.getInitialData();
    await this.getShowPhoneNumber()
  },

  methods: {
    getCarTypeName,
    formatDate(date) {
      if (!date) return '';

      let year = parseInt(moment(date).format('YYYY'));
      let m_d = moment(date).format('DD/MM');
      return `${m_d}/${year + 543}`;
    },
    add() {
      this.$router.push({ name: 'car-create' });
    },
    getItemNumber(item) {
      const page =
        this.viewMode === 'search'
          ? this.searchCursorPage
          : this.viewMode === 'initial'
          ? this.cursorPage
          : this.filter.page;
      return (
        this.list.findIndex((car) => car._id === item._id) +
        1 +
        this.filter.item_per_page * (page - 1)
      );
    },
    edit(item) {
      this.$router.push({ name: 'car-update', params: { id: item._id } });
    },
    remove(item) {
      this.$alertConfirm({ title: `ยืนยันลบข้อมูล ?`, text: `` }).then(
        async (result) => {
          if (result.isConfirmed) {
            let body = {
              token: this.$jwt.sign({ car_id: item._id }, this.$privateKey, {
                noTimestamp: true,
              }),
            };
            await this.$axios
              .post(`${this.$baseUrl}/car/delete_car`, body)
              .then((res) => {
                this.$alertSuccess({ title: res.status });
                if (this.viewMode === 'initial') {
                  this.resetInitialData();
                } else if (this.viewMode === 'search') {
                  this.resetSearchData();
                } else {
                  this.getData();
                }
              })
              .catch((err) => {
                this.$alertServerError({ title: err.error_message });
              });
            console.log('remove()');
          }
        }
      );
    },
    async getShowPhoneNumber() {
      await this.$store.dispatch('getGroupPermissions');
      this.applyGroupPermissions();
    },
    applyGroupPermissions() {
      try {
        this.show_phone_number = this.$store.state.group_permissions.show_phone_number;
        if (!this.show_phone_number) {
          this.showPhoneNumber = false;
        } else {
          this.showPhoneNumber = true;
        };
      } catch (error) {
        this.showPhoneNumber = false;
        console.error('Error in getShowPhoneNumber:', error);
      };
    }, 
    phoneNumberFormat(val) {
      if (val) {
        if (!this.showPhoneNumber) return 'XXX-XXXXXXX';
        return val.substring(0, 3) + '-' + val.substring(3, val.length);
      } else return val;
    },
    searchData() {
      clearTimeout(this.timer);
      const requestVersion = ++this.requestVersion;
      const searchQuery = this.filter.start_with.trim();
      this.searchNotFound = false;

      if (!searchQuery) {
        this.resetInitialData(requestVersion);
        return;
      }

      this.viewMode = 'search';
      this.searchQuery = searchQuery;
      this.searchCursorHistory = [null];
      this.searchCursorPage = 1;
      this.searchHasMore = false;
      this.searchNextCursor = null;
      this.timer = setTimeout(() => {
        this.getSearchData(null, searchQuery, requestVersion);
      }, 400);
    },
    async getSearchData(cursor = null, searchQuery, requestVersion) {
      if (searchQuery === undefined) {
        searchQuery = this.searchQuery;
      }
      if (requestVersion === undefined) {
        requestVersion = ++this.requestVersion;
      }
      this.loading = true;
      const body = {
        token: this.$jwt.sign(
          {
            branch_id: this.filter.branch_id,
            q: searchQuery,
            cursor,
          },
          this.$privateKey,
          { noTimestamp: true }
        ),
      };
      try {
        const res = await this.$axios.post(`${this.$baseUrl}/car/search`, body);
        if (requestVersion !== this.requestVersion) return;

        this.list = res.result.data;
        this.searchHasMore = res.result.has_more;
        this.searchNextCursor = res.result.next_cursor;
        this.searchNotFound = this.list.length === 0;
      } catch (err) {
        if (requestVersion !== this.requestVersion) return;

        console.log('err', err);
        this.$alertServerError({ title: err.error_message });
      } finally {
        if (requestVersion === this.requestVersion) {
          this.loading = false;
        }
      }
    },
    async getInitialData(cursor = null, requestVersion) {
      if (requestVersion === undefined) {
        requestVersion = ++this.requestVersion;
      }
      this.loading = true;
      const body = {
        token: this.$jwt.sign(
          {
            branch_id: this.filter.branch_id,
            initial_load: true,
            cursor,
          },
          this.$privateKey,
          { noTimestamp: true }
        ),
      };
      try {
        const res = await this.$axios.post(
          `${this.$baseUrl}/car/get_car_from_product`,
          body
        );
        if (requestVersion !== this.requestVersion) return;

        this.list = res.result.data;
        this.hasMore = res.result.has_more;
        this.nextCursor = res.result.next_cursor;
      } catch (err) {
        if (requestVersion !== this.requestVersion) return;

        console.log('err', err);
        this.$alertServerError({ title: err.error_message });
      } finally {
        if (requestVersion === this.requestVersion) {
          this.loading = false;
        }
      }
    },
    async resetInitialData(requestVersion) {
      this.viewMode = 'initial';
      this.searchNotFound = false;
      this.cursorHistory = [null];
      this.cursorPage = 1;
      await this.getInitialData(null, requestVersion);
    },
    async resetSearchData() {
      if (!this.searchQuery) {
        await this.resetInitialData();
        return;
      }

      this.viewMode = 'search';
      this.searchNotFound = false;
      this.searchCursorHistory = [null];
      this.searchCursorPage = 1;
      this.searchHasMore = false;
      this.searchNextCursor = null;
      await this.getSearchData(null, this.searchQuery);
    },
    async nextCursorPage() {
      if (!this.canGoNext || this.loading) return;

      if (this.viewMode === 'search') {
        this.searchCursorHistory.push(this.searchNextCursor);
        this.searchCursorPage += 1;
        await this.getSearchData(this.searchNextCursor);
        return;
      }

      this.cursorHistory.push(this.nextCursor);
      this.cursorPage += 1;
      await this.getInitialData(this.nextCursor);
    },
    async previousCursorPage() {
      if (!this.canGoPrevious || this.loading) return;

      if (this.viewMode === 'search') {
        this.searchCursorHistory.pop();
        this.searchCursorPage -= 1;
        await this.getSearchData(
          this.searchCursorHistory[this.searchCursorHistory.length - 1]
        );
        return;
      }

      this.cursorHistory.pop();
      this.cursorPage -= 1;
      await this.getInitialData(
        this.cursorHistory[this.cursorHistory.length - 1]
      );
    },
    async getData() {
      clearTimeout(this.timer);
      const requestVersion = ++this.requestVersion;
      this.viewMode = 'report';
      this.searchNotFound = false;
      this.loading = true;
      const body = {
        token: this.$jwt.sign(this.filter, this.$privateKey, {
          noTimestamp: true,
        }),
      };
      try {
        const res = await this.$axios.post(
          `${this.$baseUrl}/car/get_car_from_product`,
          body
        );
        if (requestVersion !== this.requestVersion) return;

        this.list = res.result.data;
        this.pageCount = res.result.total_page || 1;
      } catch (err) {
        if (requestVersion !== this.requestVersion) return;

        console.log('err', err);
        this.$alertServerError({ title: err.error_message });
      } finally {
        if (requestVersion === this.requestVersion) {
          this.loading = false;
        }
      }
    },
    async download_excel() {
      const _MS_PER_DAY = 1000 * 60 * 60 * 24;
      var date1 = new Date(this.filter.start_date);
      var date2 = new Date(this.filter.end_date);
      var diffTime = date2.getTime() - date1.getTime();
      var diffDay = Math.floor(diffTime / _MS_PER_DAY);

      // Discard the time and time-zone information.
      console.log(diffDay);
      if (diffDay > 190) {
        this.$alertServerError({
          title:
            'ไม่สามารถดาวน์โหลด<br/> มากกว่า 6 เดือน/ครั้งได้ <br/> กรุณาเลือกวันให้น้อยกว่า 6 เดือน',
        });
      } else {
        this.loading = true;
        let body = {
          token: this.$jwt.sign(this.filter, this.$privateKey, {
            noTimestamp: true,
          }),
        };
        await this.$axios({
          method: 'post',
          url: `${this.$baseUrl}/car/download_car_from_product`,
          responseType: 'blob',
          data: body,
        })
          .then((response) => {
            if (
              moment(this.filter.start_date).format('DDMMYYYY') !=
              moment(this.filter.end_date).format('DDMMYYYY')
            ) {
              this.forceFileDownload(
                response,
                'ข้อมูลรถ' +
                  moment(this.filter.start_date, 'YYYY-MM-DDTHH:mm:ss').format(
                    'DD-MM-YYYY'
                  ) +
                  '_' +
                  moment(this.filter.end_date, 'YYYY-MM-DDTHH:mm:ss').format(
                    'DD-MM-YYYY'
                  ) +
                  '.xlsx'
              );
            } else {
              this.forceFileDownload(
                response,
                'ข้อมูลรถ' +
                  moment(this.filter.start_date, 'YYYY-MM-DDTHH:mm:ss').format(
                    'DD-MM-YYYY'
                  ) +
                  '.xlsx'
              );
            }
          })
          .catch((err) => {
            console.log('err', err);
            this.$alertServerError({ title: err.error_message });
          });
        this.loading = false;
      }
    },
    forceFileDownload(response, title) {
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', title);
      document.body.appendChild(link);
      link.click();
    },
    forceFileDownload(response, title) {
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', title);
      document.body.appendChild(link);
      link.click();
    },
    onChangePage(page) {
      this.filter.page = page;
      this.getData();
    },
    onChangeitemsPerPage(number) {
      this.filter.item_per_page = number;
      this.onChangePage(1);
    },
    formatDate(date) {
      if (!date) {
        return '';
      }
      let year = parseInt(moment(date).format('YYYY'));
      let m_d = moment(date).format('DD/MM');
      if (m_d === 'Invalid date') return '';
      return `${m_d}/${year + 543}`;
    },
  },
};
</script>

<style lang="css" scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>
